
export const InterviewData = [
    {
        id:1,
        interviewName:'Level 1 interview ',
        from:"27/02/2025 11:17 PM",
        to:"28/02/2025 11:17 PM",
        candidatesName:" Ram",
        department:"Engineering",
        postingTitle:"React js",
        status: "Pending",
        interviewOwner:"Anish Agrawal"
      },
      {
        id:2,
        interviewName:'Level 1 interview ',
        from:"27/02/2025 11:17 PM",
        to:"28/02/2025 11:17 PM",
        candidatesName:" Sagar",
        department:"Engineering",
        postingTitle:"React js",
        status: "Rejected" ,
        interviewOwner:"Anish Agrawal"
      },
      {
        id:3,
        interviewName:'Level 1 interview ',
        from:"27/02/2025 11:17 PM",
        to:"28/02/2025 11:17 PM",
        candidatesName:" OM",
        department:"Engineering",
        postingTitle:"React js",
        status: "Hold" ,
        interviewOwner:"Anish Agrawal"
      },
      {
        id:4,
        interviewName:'Level 1 interview ',
        from:"27/02/2025 11:17 PM",
        to:"28/02/2025 11:17 PM",
        candidatesName:" Alok",
        department:"Engineering",
        postingTitle:"React js",
        status: "Hold" ,
        interviewOwner:"Anish Agrawal"
      },
      {
        id:5,
        interviewName:'Level 1 interview ',
        from:"27/02/2025 11:17 PM",
        to:"28/02/2025 11:17 PM",
        candidatesName:" Abhijit",
        department:"Engineering",
        postingTitle:"React js",
        status: "Hold" ,
        interviewOwner:"Anish Agrawal"
      },
]